export const REVIEW_CARD_EVENT = {
  enteredAddWorkflow: '[Review Card] Add Card workflow entered',
  openedNfcScanner: '[Review Card] NFC scanner opened',
  cardScanned: '[Review Card] Card scanned successfully',
};
